module.exports = __webpack_public_path__ + "img/7.24252d82.jpg";